"use strict";

import "./request-contract-dialog.scss";
import "./request-contract-dialog-dark.scss";

class RequestContractDialogCtrl {
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
    }
    $onInit() {}
}

angular.module("nucont.shared").controller("RequestContractDialogCtrl", [
    "$mdDialog",
    "locals",
    RequestContractDialogCtrl
]);
